var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { nothing } from 'lit';
import { t } from 'i18next';
import { customElement, property, query, state } from 'lit/decorators.js';
import { unsafeSVG } from 'lit/directives/unsafe-svg.js';
import { BaseComponent } from '../utils/BaseComponent';
import BlocketIcons from '../icons/BlocketSvgs';
import FinnIcons from '../icons/FinnSvgs';
import { SettingsController } from '../utils/SettingsController';
let Icon = class Icon extends BaseComponent {
    constructor() {
        super(...arguments);
        this.classNames = '';
        this.primary = false;
        this.icons = undefined;
        this.updateIconSet = () => {
            if (window.trustSettings && window.trustSettings.brand === 'blocket') {
                this.icons = BlocketIcons;
            }
            else {
                this.icons = FinnIcons;
            }
        };
        this._settingListener = new SettingsController(this, this.updateIconSet.bind(this));
    }
    connectedCallback() {
        super.connectedCallback();
        this.updateIconSet();
    }
    getAriaLabelText() {
        if (this.label) {
            return this.label;
        }
        if (!this.icons[this.name].ariaLabelKey) {
            // trackErrorMesssage(`The icon with name ${this.icons[this.name]} does not have an area-label defined. Please add it.`)
            return undefined; //t('No area label added yet') // maybe undefined is better :shrug:
        } // ask Martin if this is a good fallback when we forget area-labels for icons.
        return t(this.icons[this.name].ariaLabelKey);
    }
    async firstUpdated(_changedProperties) {
        var _a, _b, _c;
        (_a = this.svgElement) === null || _a === void 0 ? void 0 : _a.setAttribute('class', `${this.primary ? 'fill-icon-primary' : ''} ${this.classNames}`);
        const ariaLabel = this.getAriaLabelText();
        if (ariaLabel) {
            (_b = this.svgElement) === null || _b === void 0 ? void 0 : _b.setAttribute('aria-label', ariaLabel);
            (_c = this.svgElement) === null || _c === void 0 ? void 0 : _c.setAttribute('role', 'img');
        }
    }
    render() {
        if (!this.icons)
            return nothing;
        return unsafeSVG(this.icons[this.name].svg);
    }
};
__decorate([
    property()
], Icon.prototype, "classNames", void 0);
__decorate([
    property()
], Icon.prototype, "label", void 0);
__decorate([
    property({ type: String })
], Icon.prototype, "name", void 0);
__decorate([
    property({ type: Boolean })
], Icon.prototype, "primary", void 0);
__decorate([
    query('svg')
], Icon.prototype, "svgElement", void 0);
__decorate([
    state()
], Icon.prototype, "icons", void 0);
Icon = __decorate([
    customElement('trust-icon')
], Icon);
export { Icon };
//# sourceMappingURL=Icon.js.map